var _linearGradient, _filter, _linearGradient2, _clipPath, _linearGradient3, _radialGradient, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _g, _rect, _rect2, _rect3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 96,
    width: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    stopColor: "#fff"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    height: 1.384,
    width: 1.384,
    x: -0.192,
    y: -0.192
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 48,
    xlinkHref: "#a",
    y1: 20.221,
    y2: 138.66
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(1.0059 0 0 .99417 100 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 45.448,
    x2: 45.448,
    y1: 92.54,
    y2: 7.0165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.58824
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 48,
    cy: 90.172,
    gradientTransform: "matrix(1.1573 0 0 .99591 -7.551 .19713)",
    gradientUnits: "userSpaceOnUse",
    r: 42,
    xlinkHref: "#a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 36.357,
    x2: 36.357,
    y1: 6,
    y2: 63.893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7222,
    x2: 47.7222,
    y1: 90.4446,
    y2: 4.98728844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27429c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5072e1"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "translate(0 1)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251,
    x2: 32.251,
    xlinkHref: "#e",
    y1: 90,
    y2: 6
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(1.0238 0 0 1.0119 -1.1429 .929)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251,
    x2: 32.251,
    xlinkHref: "#e",
    y1: 90,
    y2: 5.9996
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(1.0238 0 0 -1.0119 -1.1429 98.071)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251,
    x2: 32.251,
    xlinkHref: "#e",
    y1: 6.1317,
    y2: 90.239
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 95.031c-5.5111 0-10.031-4.52-10.031-10.031v-71c0-5.5111 4.5202-10.031 10.031-10.031h72c5.5111 0 10.031 4.5202 10.031 10.031v71c0 5.5111-4.5202 10.031-10.031 10.031z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 94.031c-4.9716 0-9.0312-4.0596-9.0312-9.0312v-71c0-4.9718 4.0596-9.0314 9.0312-9.0314h72c4.9716 0 9.0312 4.0596 9.0312 9.0312v71c0 4.9716-4.0596 9.0312-9.0312 9.0312h-72z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 93c-4.4091 0-8-3.591-8-8v-71c0-4.4091 3.5909-8 8-8h72c4.4091 0 8 3.5909 8 8v71c0 4.4091-3.5909 8-8 8z",
    opacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#j)",
    height: 85,
    opacity: 0.3,
    rx: 7,
    width: 86,
    x: 5,
    y: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#i)",
    height: 84,
    opacity: 0.45,
    rx: 6,
    width: 84,
    x: 6,
    y: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#h)",
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 6c-3.324 0-6 2.676-6 6v72c0 .33472.04135.6507.09375.96875.0487.2956.09704.59692.1875.875.00988.03038.020892.0636.03125.09375.098865.28777.23488.54745.375.8125.14459.27351.31562.53562.5.78125.18438.24564.37378.47347.59375.6875.43995.42806.94291.81453 1.5 1.0938.27854.13961.57347.24695.875.34375-.2562-.10022-.48671-.23627-.71875-.375-.00741-.0044-.023866.0045-.03125 0-.0319-.019-.0622-.042-.0937-.062-.1204-.077-.231-.164-.3437-.25-.1062-.081-.2133-.161-.3126-.25-.1778-.162-.3473-.346-.4999-.531-.1075-.131-.2183-.266-.3124-.407-.0251-.038-.0385-.086-.0626-.125-.0647-.103-.1302-.204-.1874-.312-.1011-.195-.2057-.416-.2813-.625-.008-.022-.0236-.041-.0313-.063-.0318-.092-.0358-.187-.0624-.281-.0304-.107-.0704-.203-.0938-.313-.0729-.341-.125-.698-.125-1.062v-72c0-2.782 2.2182-5 5-5h72c2.7818 0 5 2.2182 5 5v72c0 .3643-.05212.72099-.125 1.0625-.04415.20689-.08838.39766-.15625.59375-.0077.02195-.0233.04069-.03125.0625-.06274.17374-.13838.36745-.21875.53125-.04158.0828-.07904.16995-.125.25-.0546.09721-.12677.18835-.1875.28125-.09411.14096-.20492.276-.3125.40625-.14317.17445-.30314.347-.46875.5-.01117.0102-.01998.02115-.03125.03125-.13839.12556-.28509.23444-.4375.34375-.10257.07315-.20432.15336-.3125.21875-.0074.0045-.02384-.0044-.03125 0-.23204.13873-.46255.27478-.71875.375.30153-.0968.59646-.20414.875-.34375.55709-.27922 1.0601-.66569 1.5-1.0938.21997-.21403.40937-.44186.59375-.6875s.35541-.50774.5-.78125c.14012-.26505.27614-.52473.375-.8125.01041-.03078.02133-.06274.03125-.09375.09046-.27808.1388-.5794.1875-.875.053-.318.094-.634.094-.969v-72c0-3.324-2.676-6-6-6h-72z",
    fill: "url(#g)",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 90c-3.324 0-6-2.676-6-6v-72c0-.33472.04135-.6507.09375-.96875.0487-.2956.09704-.59692.1875-.875.0099-.03.0209-.063.0313-.094.0989-.2873.2349-.547.375-.812.1446-.2735.3156-.5356.5-.7812.1844-.2457.3738-.4735.5937-.6876.44-.428.943-.8145 1.5-1.0937.2786-.1396.5735-.2469.8748-.3437-.256.1002-.4865.2362-.7185.375-.00741.0044-.023866-.0045-.03125 0-.031933.0193-.062293.04251-.09375.0625-.1204.0767-.23102.16351-.34375.25-.10617.0808-.21328.16111-.3125.25-.1779.1614-.3474.3453-.5.5312-.1075.1303-.2183.2653-.3124.4063-.0251.0383-.0385.0858-.0626.125-.0647.103-.1302.2045-.1874.3124-.1011.1948-.2057.4158-.2813.625-.008.0219-.0236.0406-.0313.0626-.0318.0919-.0358.1868-.0624.2812-.0304.1066-.0704.203-.0938.3125-.0729.3415-.125.6985-.125 1.0625v72c0 2.7818 2.2182 5 5 5h72c2.7818 0 5-2.2182 5-5v-72c0-.364-.052-.721-.125-1.0625-.044-.2069-.088-.3977-.156-.5937-.008-.022-.024-.0407-.031-.0626-.063-.1737-.139-.3674-.219-.5312-.042-.0828-.079-.17-.125-.25-.055-.0972-.127-.1884-.188-.2812-.094-.141-.205-.276-.312-.4063-.143-.1745-.303-.347-.469-.5-.011-.0102-.02-.0211-.031-.0313-.139-.1255-.285-.2344-.438-.3437-.102-.0731-.204-.1534-.312-.2187-.0074-.0045-.02384.0044-.03125 0-.23204-.13873-.46255-.27478-.71875-.375.30153.0968.59646.20414.875.34375.55709.27922 1.0601.66569 1.5 1.0938.21997.21403.40937.44186.59375.6875s.35541.50774.5.78125c.14012.26505.27614.52473.375.8125.01041.03078.02133.06274.03125.09375.09046.27808.1388.5794.1875.875.053.318.094.634.094.969v72c0 3.324-2.676 6-6 6h-72z",
    fill: "url(#f)",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("rect", {
    height: 66,
    rx: 12,
    style: {
      opacity: 0.1,
      stroke: "#fefefe",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      clipPath: "url(#d)",
      fill: "url(#c)",
      filter: "url(#b)"
    },
    width: 66,
    x: 15,
    y: 15
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m47.02754 77.888602c-2.23619-.40412-5.89541-1.09964-8.13161-1.54559-2.23619-.44596-4.34728-.82024-4.69131-.83174s-1.04773-.13609-1.56377-.27687c-.51604-.14077-1.71233-.33996-2.65841-.44264s-2.21274-.24735-2.81479-.32149c-1.45247-.17888-11.07642-1.80815-11.19737-1.89564-.21909-.15849-.0548-47.496297.16556-47.700822.13299-.123435 4.53434-.943285 9.7808-1.821889 13.47732-2.256997 24.09146-4.048118 25.09852-4.235337l.86007-.159894v30.016581c0 23.822491-.0807 30.009721-.39094 29.983331-.21502-.0183-2.22056-.36388-4.45675-.768zm-6.7222-18.51132c.002-.199597 4.06085-19.226925 4.537-21.267284.15731-.674086.0792-.703697-1.85619-.703697-1.11122 0-2.11236.1488-2.22476.330665s-.67991 3.242947-1.26113 6.802403c-1.1122 6.811181-1.34845 8.025442-1.52493 7.837849-.0596-.0633-.71126-3.316914-1.44824-7.230251l-1.33997-7.115157h-1.95837c-1.07711 0-2.02195.105555-2.09965.234565-.0777.129012-.73473 3.190093-1.46006 6.802403-.72533 3.612312-1.41556 6.672971-1.53384 6.801466s-.60299-2.334447-1.07712-5.473199c-.47414-3.138754-.94059-6.164228-1.03656-6.723276-.17415-1.014438-.17821-1.016451-2.05102-1.016451h-1.87653l.20628 1.172828c.11346.645056.82812 4.409834 1.58815 8.366174.76002 3.956341 1.47181 7.772082 1.58175 8.479423.10994.707343.29055 1.429299.40137 1.604347.11082.175049 1.06706.417752 2.12498.539341l1.92348.221077.47746-2.138175c.2626-1.175996.8598-4.108526 1.32712-6.516733.46733-2.408208.94672-4.488755 1.06531-4.623439.1186-.134685.82649 2.849031 1.57309 6.630482 1.32703 6.721293 1.37551 6.878165 2.16333 7.000423 1.4866.2307 3.77702.221133 3.77905-.01579zm13.13366 9.14806v-3.28392h9.69538 9.69538v-1.25102-1.25101h-9.69538-9.69538v-1.876528-1.876525h9.69538 9.69538v-1.251017-1.251016h-9.69538-9.69538v-1.876525-1.876525h9.69538 9.69538v-1.251017-1.251016h-9.69538-9.69538v-1.876526-1.876525h9.69538 9.69538v-1.251017-1.251016h-9.69538-9.69538v-1.876525-1.876525h9.69538 9.69538v-1.251017-1.251016h-9.69538-9.69538v-1.876525-1.876525h9.69538 9.69538v-1.251017-1.251016h-9.69538-9.69538v-2.971165-2.971164h12.13486c9.02122 0 12.23116.0963 12.51017.375305.54303.543028.54303 44.993973 0 45.537003-.27901.27901-3.48895.37531-12.51017.37531h-12.13486z",
    fill: "#fefefe",
    strokeWidth: 0.312754
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsWord);
export default __webpack_public_path__ + "static/media/ms-word.032147c29ab1e858af2f42e7babc051c.svg";
export { ForwardRef as ReactComponent };